import { configureStore } from '@reduxjs/toolkit'
import clubFinderMapResultSlice from "./slices/clubFinderResultMapSlice";
import widgetConfigurationSlice from "./slices/widgetConfigurationSlice";
import clubFinderSearchBarSlice from "./slices/clubFinderSearchBarSlice";

export const store = configureStore({
  reducer: {
    clubFinderMapResultStore: clubFinderMapResultSlice,
    widgetConfigurationSettings: widgetConfigurationSlice,
    clubFinderSearchBarStore: clubFinderSearchBarSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
